// extracted by mini-css-extract-plugin
export default {"root":"IconHotelLaundry_root__om+u0"};